import * as React from 'react';
import * as signalR from '@microsoft/signalr';
import { SignalRHubProps, SignalRHub } from './signlarhub';
import * as flightAwareMessages from '../models/flightawaremessages';

interface FlightAwareHubProps extends SignalRHubProps {
    children?: (flightAwareHub: FlightAwareHub) => React.ReactNode
}

interface FlightAwareMessages {
    flightAwareFlightId: string;
    messages: flightAwareMessages.FlightMessage[];
}

export class FlightAwareHub extends SignalRHub<FlightAwareHubProps> {

    static displayname = "SignalR.FlightAwareHub";

    connected = false;

    willConnect(connection: signalR.HubConnection) {
        connection.on("Messages", (m: FlightAwareMessages) => (this.listeners[m.flightAwareFlightId] || []).forEach(f => f(m.messages)));
    }

    didConnect() {
        this.connected = true;
        this.addDisconnectListener(this.onDisconnect)
    }

    onDisconnect = () => { this.connected = false }

    private listeners: { [flight: string]: ((messages: flightAwareMessages.FlightMessage[]) => void)[] } = {}

    public listen(flightAwareFlightIds: string[], onMessages: (messages: flightAwareMessages.FlightMessage[]) => void) {
        for (let flightAwareFlightId of flightAwareFlightIds) {
            (this.listeners[flightAwareFlightId] || (this.listeners[flightAwareFlightId] = [])).push(onMessages);
        }
        this.invoke<flightAwareMessages.FlightMessage[]>("Listen", flightAwareFlightIds);
    }

    public unlisten(flightAwareFlightIds: string[], onMessages: (messages: flightAwareMessages.FlightMessage[]) => void) {
        // Our children will unmount AFTER us, and we don't need to do any special cleanup, so just ignore them.
        if (!this.connected) return;

        for (let flightAwareFlightId of flightAwareFlightIds) {
            let listeners = this.listeners[flightAwareFlightId];
            let index: number;
            if (listeners && (index = listeners.indexOf(onMessages)) > -1) {
                listeners.splice(index, 1);
                if (listeners.length === 0) {
                    this.send("Unlisten", flightAwareFlightId);
                    delete this.listeners[flightAwareFlightId];
                }
            }
        }
    }

    render() {
        return this.props.children ? this.props.children(this) : null;
    }
}